(function () {
    'use strict';

    function main() {

        var page = wo$('#location-page');
        if (!page.length) return;

        var controller = {

            init: function () {
                page.find('#cheapest-plans tr.hover-bg').click(function () {
                    var url = wo$(this).find('a').attr('href');
                    if (url) {
                        location.href = url;
                    }
                });

                WhistleOut.bindCitiesAutoComplete(page);

                WhistleOut.getAds('Broadband');
            }

        };

        controller.init();
    };

    WhistleOut.initModule(import.meta.url, main);

}());
